import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from './lib/cn';

export const Surface = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  function Surface({ className, ...props }, ref) {
    return (
      <div
        ref={ref}
        className={cn(
          'rounded-[var(--radius-lg)] border border-[color-mix(in_srgb,var(--foreground)_7%,transparent)] dark:border-white/10 bg-[var(--surface)] shadow-[var(--shadow-sm)] backdrop-blur-md transition-all duration-200',
          className,
        )}
        {...props}
      />
    );
  },
);
